<template>
  <v-app id="app" color="grey lighten-4">
    <v-main>
      <!-- <router-view></router-view> -->
      <router-view v-slot="{ Component }">
        <transition>
          <keep-alive>
            <component :is="Component" />
          </keep-alive>
        </transition>
      </router-view>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),
};
</script>

<style lang="scss">
#app {
  font-family: "微軟正黑體";
}
</style>